// extracted by mini-css-extract-plugin
module.exports = {"topBtns":"FsBuildTop_topBtns__18w0V","isPlain":"FsBuildTop_isPlain__-zKCB","topBtnsCenter":"FsBuildTop_topBtnsCenter__1utwL"};